
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const ServiceLimitationsSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Service Limitations and Disclaimers</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          <strong>No Guarantee of Complete Filtering:</strong> While we strive to provide effective content filtering, 
          SocialScoop makes no guarantee that all unwanted content will be blocked or filtered. Our service uses 
          automated systems and AI technology that, while advanced, are not infallible.
        </p>
        
        <p>
          You acknowledge and agree that:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>Some harmful, offensive, or unwanted content may still appear in your social media feeds</li>
          <li>Our filtering technology may occasionally block content you would prefer to see</li>
          <li>Third-party social media platforms may change their APIs, affecting our service functionality</li>
          <li>Network issues, technical problems, or platform outages may temporarily impact filtering effectiveness</li>
        </ul>
        
        <p className="mt-4">
          <strong>User Responsibility:</strong> You remain responsible for your own social media experience and 
          should continue to exercise personal judgment and discretion when engaging with social media content.
        </p>
        
        <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-amber-800 text-sm">
            <strong>Important:</strong> SocialScoop is a filtering tool designed to improve your social media 
            experience, but it is not a substitute for personal vigilance, parental supervision, or professional 
            mental health support when needed.
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const DataUsageRightsSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Data Usage and Research Rights</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          By using SocialScoop, you grant us certain rights to use data generated through your use of our service 
          for research, development, and service improvement purposes.
        </p>
        
        <div className="space-y-3">
          <h3 className="font-semibold">Data We May Use for Research</h3>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Content that has been filtered or blocked by our system</li>
            <li>Filtering rule effectiveness and performance metrics</li>
            <li>User interaction patterns with filtered content (anonymized)</li>
            <li>Sentiment analysis results and categorization data</li>
            <li>Platform usage statistics and feature adoption rates</li>
          </ul>
          
          <h3 className="font-semibold mt-4">How We Use This Data</h3>
          <p>
            We may use aggregated and anonymized data for:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Improving our AI filtering algorithms and accuracy</li>
            <li>Developing new features and services</li>
            <li>Conducting research on digital wellness and social media behavior</li>
            <li>Creating industry reports and insights (with no individual identification)</li>
            <li>Training machine learning models to better detect harmful content</li>
          </ul>
          
          <h3 className="font-semibold mt-4">Privacy Protections</h3>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>All research data is aggregated and anonymized before use</li>
            <li>Personal identifiers are removed from research datasets</li>
            <li>Individual users cannot be identified from research outputs</li>
            <li>We do not sell individual user data to third parties</li>
            <li>Research findings may be shared publicly but only in aggregate form</li>
          </ul>
        </div>
        
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-blue-800 text-sm">
            <strong>Your Rights:</strong> While you grant us these data usage rights, you retain ownership of your 
            personal information. You can request deletion of your data at any time, though anonymized research 
            data cannot be retroactively removed from completed studies.
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);
